<form [formGroup]="form" (submit)="searchUserHandler()">
    <div class="row">
        <div class="col-sm-6 col-lg-12 d-flex">
            <div class="form-group w-50">
                <label for="nombreIdEmpleado">
                    Nombre o número de emplado:
                </label>
                <input 
                    id="nombreIdEmpleado"
                    name="nombreIdEmpleado"
                    type="text"
                    class="form-control"
                    formControlName="nombreIdEmpleado"
                />
            </div>
            <button
                [disabled]="form.invalid || btnBuscarEnabled"
                class="btn btn-sm btn-primary btn-search-user"
                type="submit"
            >
                <i class="fa fa-search"></i> Buscar
            </button>
        </div>
    </div>
</form>